import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';

export const AccountSettingRepository = {
  getAccountSettings: (settings) => {
    const config = DependencyResolver.get('component/config/index');
    const cid = _.result(config.get('CurrentCustomer'), 'Id');
    const aid = _.result(config.get('CurrentAccount'), 'Id');
    const url = `${config.get('odata.url')}${config.get('odata.path')}/Customers(${cid})/Accounts(${aid})?$select=${settings.join(',')}`;

    return odata.get(url, { oDataToken: config.get('odata.token') });
  },

  updateAccountSettings: (data) => {
    const config = DependencyResolver.get('component/config/index');
    const cid = _.result(config.get('CurrentCustomer'), 'Id');
    const aid = _.result(config.get('CurrentAccount'), 'Id');

    const url = `${config.get('odata.url')}${config.get('odata.path')}/Customers(${cid})/Accounts(${aid})`;
    return odata.patch(url, { data, oDataToken: config.get('odata.token') });
  },
};
